module.exports = __webpack_public_path__ + "media/images/icon_arrow_gray3-4a950d5122c247c3072bd38fbe28487a.png";